import React, { SVGProps } from 'react';

export const PdfSVG = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_4473_1786)'>
        <path
          d='M3.89944 12.0989V7.9989'
          stroke='currentColor'
          strokeWidth='0.88'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3.89999 8H4.30999C4.63621 8 4.94907 8.12959 5.17974 8.36026C5.4104 8.59093 5.53999 8.90378 5.53999 9.23C5.53999 9.55622 5.4104 9.86907 5.17974 10.0997C4.94907 10.3304 4.63621 10.46 4.30999 10.46H3.89999'
          stroke='currentColor'
          strokeWidth='0.88'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M7.17999 12.1C7.61495 12.1 8.03209 11.9272 8.33965 11.6197C8.64721 11.3121 8.81999 10.895 8.81999 10.46V9.64C8.81999 9.42463 8.77757 9.21137 8.69516 9.0124C8.61274 8.81343 8.49194 8.63263 8.33965 8.48034C8.18736 8.32806 8.00657 8.20726 7.80759 8.12484C7.60862 8.04242 7.39536 8 7.17999 8V12.1Z'
          stroke='currentColor'
          strokeWidth='0.88'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.46 12.1V8.82C10.46 8.71232 10.4812 8.60569 10.5224 8.5062C10.5636 8.40671 10.624 8.31632 10.7002 8.24017C10.7763 8.16403 10.8667 8.10363 10.9662 8.06242C11.0657 8.02121 11.1723 8 11.28 8H12.1'
          stroke='currentColor'
          strokeWidth='0.88'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.4594 10.4589H11.6894'
          stroke='currentColor'
          strokeWidth='0.88'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.9089 4.47892C14.0627 4.63255 14.1493 4.84098 14.1495 5.05839V12.92C14.1492 13.2459 14.0195 13.5584 13.789 13.7888C13.5585 14.0193 13.2459 14.1488 12.92 14.1489H3.08C2.75388 14.1491 2.44105 14.0197 2.2103 13.7892C1.97954 13.5588 1.84975 13.2461 1.84946 12.92V3.08C1.84931 2.91834 1.88104 2.75823 1.94282 2.60884C2.00461 2.45945 2.09523 2.3237 2.20952 2.20936C2.32381 2.09502 2.45952 2.00433 2.60888 1.94248C2.75825 1.88063 2.91834 1.84884 3.08 1.84891H10.9394C11.0471 1.84886 11.1538 1.87003 11.2533 1.9112C11.3528 1.95238 11.4433 2.01276 11.5194 2.08889L13.9089 4.47892Z'
          stroke='currentColor'
          strokeWidth='0.88'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M10.8694 1.84891V4.30891C10.8694 4.52639 10.9558 4.73496 11.1096 4.88874C11.2634 5.04251 11.472 5.12891 11.6894 5.12891H14.1494'
          stroke='currentColor'
          strokeWidth='0.88'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_4473_1786'>
          <rect width='14' height='14' fill='white' transform='translate(1 1)' />
        </clipPath>
      </defs>
    </svg>
  );
};
